import HTTP from '../HTTP';
import getNumsReseauxTempo from '../../services/general/gestionNumReseauxTempo';

const RESEAUX_URL = 'Reseaux/';

export async function browseReseaux(dateDeVisualisation, avecConfreres, agenceIds, estLc) {
  try {
    const response = await HTTP.get(RESEAUX_URL + '?datevisualisation=' + dateDeVisualisation + '&avecConfreres=' + avecConfreres + '&agenceIds=' + agenceIds + '&estLc=' + estLc);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function sendColor(num, couleur) {
  try {
    const response = await HTTP.post(RESEAUX_URL + num + '/couleur', { couleur });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getPropositions(debut, fin, resNums) {
  try {
    const resnums = getNumsReseauxTempo(resNums);
    for (let index = 0; index < resnums.length; index += 1) {
      resnums[index] = resnums[index].toString();
    }
    const response = await HTTP.post(RESEAUX_URL + 'propositions', { debut, fin, resnums });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getPlaningReseauxPdf(debut, fin, resnums, listInfoReseaux, user) {
  try {
    const response = await HTTP.post(RESEAUX_URL + 'planingPdf', { debut, fin, resnums, listInfoReseaux, user }, { responseType: 'blob' });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getFacesReseau(num, params) {
  try {
    const response = await HTTP.get(RESEAUX_URL + num + '/faces', params);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getFacesSelectionneesIndispo(facesIds, anneeSemaine) {
  try {
    const response = await HTTP.post(RESEAUX_URL + 'getFacesIndispo', {
      produitIds: facesIds,
      anneeSemaine,
    });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function commandesLc() {
  try {
    const response = await HTTP.get(RESEAUX_URL + 'commandesLc');
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getPlaningReseauxLcPdf(dateVisualisation, avecConfreres, estLc, user,
  resNums) {
  try {
    const response = await HTTP.post(RESEAUX_URL + 'planingPdfReseauxLc', { dateVisualisation, avecConfreres, estLc, user, resNums }, { responseType: 'blob' });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getCompletReseauTempoAsync(id, params) {
  try {
    const response = await HTTP.get(RESEAUX_URL + 'GetCompletReseauTempoAsync/' + id, {
      params,
    });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getCompletReseauLcAsync(id) {
  try {
    const response = await HTTP.get(RESEAUX_URL + 'GetCompletReseauLcAsync/' + id);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getReseau(payload, id) {
  try {
    const response = await HTTP.get(RESEAUX_URL + 'GetAsync/' + id, {
      params: payload,
    });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getFicheProduitReseauTempo(data) {
  try {
    const response = await HTTP.post(RESEAUX_URL + 'fichePdf/', data, { responseType: 'blob' });
    return response;
  } catch (e) {
    throw e;
  }
}



// WEBPACK FOOTER //
// ./src/api/reseaux/index.js